export const GET_INBOUND_MAIL_REQUEST = 'GET_INBOUND_MAIL_REQUEST';
export const RESOLVE_INBOUND_MAIL_REQUEST = 'RESOLVE_INBOUND_MAIL_REQUEST';
export const GET_INBOUND_MAIL_OAUTH_STATUS_REQUEST = 'GET_INBOUND_MAIL_OAUTH_STATUS_REQUEST';

export const getInboundMail = (status, callback) => ({
    type: GET_INBOUND_MAIL_REQUEST,
    payload: { status, callback },
});

export const resolveInboundMail = (id, body, callback) => ({
    type: RESOLVE_INBOUND_MAIL_REQUEST,
    payload: { id, body, callback },
});

export const getInboundMailOauthStatus = (callback) => ({
    type: GET_INBOUND_MAIL_OAUTH_STATUS_REQUEST,
    payload: { callback },
});
